import FormGroupRenderer from '@app/components/FormGroupRenderer'
import PageSection from '@app/components/PageSection'
import PillListRenderer from '@app/components/PillListRenderer'
import { formatAddressSingleLine } from '@app/utils/formatting'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { DevelopmentSiteViewPageProps } from './DevelopmentSiteViewPage'

export default class DevelopmentSiteTeam extends React.PureComponent<
  DevelopmentSiteViewPageProps
> {
  public render() {
    return (
      <DocumentTitle
        title={`${this.props.site.client.name} :: ${formatAddressSingleLine(
          this.props.site.address,
        )} :: Team`}
      >
        <PageSection title='Team Members'>
          {this.props.site.team
            .sortBy((t) => (t !== undefined ? t.name : undefined))
            .toArray()
            .map((role) => (
              <FormGroupRenderer key={role.key} labelText={role.name}>
                <PillListRenderer
                  list={role.members}
                  baseNavigateUrl='/connection'
                  idValue='contactId'
                />
              </FormGroupRenderer>
            ))}
        </PageSection>
      </DocumentTitle>
    )
  }
}
